module.exports = __webpack_public_path__ + "static/album-mahler-lieder.bcf9e2ea.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/album-mahler-lieder.jpg
// module id = 1319
// module chunks = 4